import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { consultationRelatedPages } from '@/mocks/consultationData';

export default function RelatedPages() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('consultation.related.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('consultation.related.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('consultation.related.titleEn')}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {consultationRelatedPages.map((page, idx) => (
            <Link
              key={idx}
              to={page.href}
              className="card-glow group block bg-background-100/60 border border-background-200/60 p-5 cursor-pointer"
            >
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {t(`consultation.related.item.${idx}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">
                {t(`consultation.related.item.${idx}.desc`)}
              </p>
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">{t('consultation.related.arrowLabel')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
